import React from 'react';
import PropTypes from 'prop-types';
import pageLoadingIndicator from '@mapbox/mr-ui/page-loading-indicator';
import {
  addRouteChangeStartListener,
  addRouteChangeEndListener
} from '@mapbox/batfish/modules/route-change-listeners';
import { AppContext } from './examples/rmts-basic-recipe/context.js';

if (typeof window !== 'undefined') {
  import(
    /* webpackChunkName: "assembly-js" */ '@mapbox/mbx-assembly-docs/dist/assembly.js'
  );
}

addRouteChangeStartListener(() => {
  pageLoadingIndicator.start();
});
addRouteChangeEndListener(() => {
  pageLoadingIndicator.end();
});

class ApplicationWrapper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      preferredLanguage: {
        ios: 'swift',
        android: 'java',
        react: 'hooks'
      },
      userAccessToken: undefined
    };
  }
  render() {
    const context = {
      preferredLanguage: {
        ios: this.state.preferredLanguage.ios,
        android: this.state.preferredLanguage.android,
        react: this.state.preferredLanguage.react
      },
      changeLanguage: {
        ios: (nextLang) => {
          this.setState({
            preferredLanguage: {
              ...this.state.preferredLanguage,
              ios: nextLang
            }
          });
        },
        android: (nextLang) => {
          this.setState({
            preferredLanguage: {
              ...this.state.preferredLanguage,
              android: nextLang
            }
          });
        },
        react: (nextLang) => {
          this.setState({
            preferredLanguage: {
              ...this.state.preferredLanguage,
              react: nextLang
            }
          });
        }
      },
      userAccessToken: this.state.userAccessToken
    };
    return (
      <AppContext.Provider value={context}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

ApplicationWrapper.propTypes = {
  children: PropTypes.node
};

export default ApplicationWrapper;
